import { Chip, Icon, Tooltip } from '@mui/material';

export default function Choice(props) {
    const value = props.filter.options.find(option => option.value == props.value).label;

    const chipData = {
        title: props.filter.tooltip ?? value,
        label: `${props.filter.label}${props.filter.tooltip ? `: ${value}` : ''}`
    };

    const { title, label } = chipData;

    return (
        <Tooltip title={title} arrow>
            <Chip label={label} onClick={props.onClick} onDelete={() => props.handleDelete(props.filter.name)} deleteIcon={<Icon>close</Icon>} />
        </Tooltip>
    );
}
